// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"cfd20465","453":"726ee2d3","591":"5bfad862","680":"d739211c"}[chunkId] + ".chunk.js";
};